import { appLayout } from '#app/init_app_layout.svelte.ts'
import { getQuerystringParameter } from '#app/lib/querystring_helpers'
import { addRoutes } from '#app/lib/router'
import { commands, reqres } from '#app/radio'
import type { AddLayoutProps } from '#inventory/components/add/add_layout.svelte'

export default {
  initialize () {
    addRoutes({
      '/add(/search)(/)': 'showSearch',
      '/add/scan(/)': 'showScan',
      '/add/scan/embedded(/)': 'showEmbeddedScanner',
      '/add/import(/)': 'showImport',
    }, controller)

    initializeHandlers()
  },
}

const controller = {
  showSearch () {
    return showAddLayout('search')
  },
  showScan () {
    return showAddLayout('scan')
  },
  showImport () {
    const isbnsStr = getQuerystringParameter('isbns')
    const isbns = typeof isbnsStr === 'string' ? isbnsStr.split('|') : undefined
    return showAddLayout('import', { isbns })
  },
  async showEmbeddedScanner () {
    if (reqres.request('require:loggedIn', 'add/scan/embedded')) {
      return showAddLayout('scan', { showBarcodeScanner: true })
    }
  },
} as const

async function showAddLayout (tab = 'search', options: Omit<AddLayoutProps, 'tab'> = {}) {
  if (reqres.request('require:loggedIn', `add/${tab}`)) {
    const { default: AddLayout } = await import('./components/add/add_layout.svelte')
    appLayout.showChildComponent('main', AddLayout, {
      props: {
        tab,
        ...options,
      },
    })
  }
}

export function showAddLayoutImportIsbns (isbns: string[]) {
  return showAddLayout('import', { isbns })
}

const initializeHandlers = () => commands.setHandlers({
  'show:add:layout': showAddLayout,
  // equivalent to the previous one as long as search is the default tab
  // but more explicit
  'show:add:layout:search': controller.showSearch,

  'show:scan': controller.showScan,

  'show:scanner:embedded': controller.showEmbeddedScanner,
})
